/* global document */
document.addEventListener('click', (event) => {
	if (!event.target.classList.contains('js-menu-toggle')) {
		return;
	}

	document.querySelectorAll('.js-menu-toggle').forEach((menuToggle) => menuToggle.classList.toggle('show'));
	document.querySelectorAll('.js-menu').forEach((menu) => menu.classList.toggle('show'));
});
